import { api } from '../utils/request'

export const trianBooking = async (data) => {
    const resp = await api({
        endpoint: '/trainBooking',
        method: 'POST',
        data,
    })
    return resp
}